export enum TypeModal {
  Default = 'default',
  Filter = 'filter',
}
export interface FormField {
  key: string;
  label?: string;
  subLabel?: string;
  value?: any;
  placeholder?: any;
  type?: string;
  required?: boolean;
  blockEventChanged?: boolean;
  condition?: { key: string; condition: '=' | '!='; value: any }[] | boolean | null | undefined;
  order?: number;
  disabled?: boolean | { key: string; condition: '=' | '!='; value: any }[];
  width?: 'full' | '1/2' | '1/3' | '1/4' | '1/5';
  remove?: boolean;
  reload?: boolean;
  customAfter?: { title: string; class?: string };
  options?: {
    data?: { id: string; text: string }[] | any[];
    select2Options?: any;
    class?: string;
    image?: string;
    width?: string;
    minDate?: any;
    dateOptions?: any;
    placement?: any;
    displayWidth?: any;
    checkInline?: boolean;
    buttons?: {
      title: string;
      width: 'full' | '1/2' | '1/3' | '1/4' | '1/5';
      classes: string;
      value: any;
    }[];
  };
}

export interface ModalContent {
  type: string;
  title: string;
  subtitle?: string;
  submit_title?: string;
}
export enum InputAddonLast {
  Remove = 'fa-trash',
}
export enum ModalType {
  Primary = 'primary',
  Warning = 'warning',
  Info = 'info',
  Danger = 'danger',
}
export enum FormFieldType {
  Custom = 'custom',
  Text = 'text',
  TextEditor = 'text_editor',
  Hidden = 'hidden',
  Number = 'number',
  Textarea = 'textarea',
  CheckBox = 'checkbox',
  Radio = 'radio',
  Switch = 'switch',
  Select = 'select',
  Select2 = 'select2',
  Color = 'color',
  Datepicker = 'datepicker',
  Timepicker = 'timepicker',
  Range = 'range',
  File = 'file',
  FileAttach = 'file_attach',
  Note = 'note',
  DisplayItem = 'display_item',
  GroupItem = 'group_item',
  Password = 'password',
  Line = 'line',
  CustomButton = 'custom_button',
  DayOfWeekPicker = 'day_of_week_picker',
  InfiniteSelect = 'infinite_select',
}

export class FormFieldConst {
  static mapWith(width) {
    switch (width) {
      case '1/2':
        return 'w-1';
      case '1/3':
        return 'w-2';
      case '1/4':
        return 'w-3';
      case '1/5':
        return 'w-4';
      default:
        return 'w-full';
    }
  }
  static mapWithSelect2(width) {
    switch (width) {
      case '1/2':
        return '48%';
      case '1/3':
        return '32%';
      case '1/4':
        return '24%';
      case '1/5':
        return '19%';
      default:
        return 'full';
    }
  }
  static parseCondition(model: any, condition: any) {
    if (typeof condition == 'boolean') {
      return condition;
    }
    if (!condition) {
      return true;
    }
    let constd = false;
    if (condition && condition.length > 0) {
      for (const item of condition) {
        const sValue = model[item.key];
        if (sValue === undefined || sValue === null) {
          continue;
        }
        if (item.condition == '=') {
          if (model[item.key] == item.value) {
            constd = true;
          }
        } else if (item.condition == '!=') {
          if (model[item.key] != item.value) {
            constd = true;
          }
        }
      }
    }
    return constd;
  }
  static parseDisabledCondition(model: any, condition: any) {
    if (typeof condition == 'boolean') {
      return condition;
    }
    if (condition && condition.length > 0) {
      for (const item of condition) {
        if (item.condition == '=') {
          return model[item.key] == item.value;
        } else if (item.condition == '!=') {
          return model[item.key] != item.value;
        }
      }
    } else {
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/modal-form-template/modal-form.const.ts